import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataServiceService } from "../data-service.service";
import { DateHelperServiceService } from "../helpers/date-helper-service.service";

@Component({
  selector: "app-all-admins",
  templateUrl: "./all-admins.component.html",
  styleUrls: ["./all-admins.component.scss"],
})
export class AllAdminsComponent implements OnInit {
  isLoading: boolean = true;
  searchTerm = "";
  allUsers = [];

  constructor(
    private router: Router,
    private dataService: DataServiceService,
    public dateHelper: DateHelperServiceService
  ) {
    this.getAllUsers().then(() => {
      this.isLoading = false;
    });
  }

  ngOnInit(): void {}

  addNewUser() {
    this.router.navigate(["/new-admin"]);
  }

  viewUserDetails(userId) {
    this.router.navigate(["/view-admin", userId]);
  }

  isAdverseMediaEnabled(user) {
    return user && user.isAdverseMediaEnabled === true;
  }

  onAdverseMediaChange(enabled: boolean, user) {
    const previous = this.isAdverseMediaEnabled(user);
    user.isAdverseMediaEnabled = enabled;
    this.dataService
      .updateAdverseMediaEnabled(user.userId, enabled)
      .catch(() => {
        user.isAdverseMediaEnabled = previous;
        alert("Failed to update Adversary Media Search setting.");
      });
  }

  async getAllUsers() {
    this.allUsers = await this.dataService.getAllAdmins();
  }
}
